// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  container: {
    display: "flex", 
    flexDirection: "column", 
    overflowY: "scroll",
    width: 
    "100%", 
    height: "100%", 
    padding: 32
  }
}))